/* -----------------UI--------------- */
import MasonryGrid from "../MasonryGrid";

interface ProgressCardsContainerProps {
	cards: React.ReactElement[];
}
const ProgressCardsContainer = ({ cards }: ProgressCardsContainerProps) => {
	return <MasonryGrid>{cards}</MasonryGrid>;
};

export default ProgressCardsContainer;
